import { render, staticRenderFns } from "./ParentCreate.vue?vue&type=template&id=6f657f16"
import script from "../../../controllers/custom/parent/parent-create.js?vue&type=script&lang=js&external"
export * from "../../../controllers/custom/parent/parent-create.js?vue&type=script&lang=js&external"
import style0 from "./ParentCreate.vue?vue&type=style&index=0&id=6f657f16&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports